/**
 * @public
 */
// 가격은 1의 자리 올림으로 처리한다. ex) 12311원의 경우 12320원
export function ceilUnit(price: number) {
  return Math.ceil(Math.floor(price) / 10) * 10;
}
